<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="boxnote"><a id="page_vi"></a><strong>NOTE:</strong> If you purchased this book without a cover you should be aware that this book is stolen property. It was reported as “unsold and destroyed” to the publisher, and neither the author nor the publisher has received any payment for this “stripped book.”</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="para"> </p>
<p class="para"><span class="smallcaps">SECOND SKIN</span></p>
<p class="para"> </p>
<p class="para">Copyright © 2009 by Caitlin Kittredge.</p>
<p class="para">Excerpt from <em>Witch Craft</em> copyright © 2009 by Caitlin Kittredge.</p>
<p class="para"> </p>
<p class="para">All rights reserved.</p>
<p class="para"> </p>
<p class="para">For information address St. Martin’s Press, 175 Fifth Avenue, New York, NY 10010.</p>
<p class="para"> </p>
<p class="para">ISBN: 0-312-94831-X</p>
<p class="para">EAN: 978-0-312-94831-3</p>
<p class="para"> </p>
<p class="para">Printed in the United States of America</p>
<p class="para"> </p>
<p class="para">St. Martin’s Paperbacks edition / March 2009</p>
<p class="para"> </p>
<p class="para">St. Martin’s Paperbacks are published by St. Martin’s Press, 175 Fifth Avenue, New York, NY 10010.</p>
<p class="para"> </p>
<p class="para">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?36af9dcd